import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeeScheduleFacade } from '@principle-theorem/ng-clinical-charting/store';
import { PipesModule } from '@principle-theorem/ng-shared';
import { type IFeeSchedule } from '@principle-theorem/principle-core/interfaces';
import {
  isSameRef,
  shareReplayCold,
  type WithRef,
} from '@principle-theorem/shared';
@Component({
  selector: 'pr-staff-fee-schedule-menu-items',
  templateUrl: './staff-fee-schedule-menu-items.component.html',
  styleUrl: './staff-fee-schedule-menu-items.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    PipesModule,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule,
  ],
})
export class StaffFeeScheduleMenuItemsComponent {
  private _feeScheduleStore = inject(FeeScheduleFacade);

  feeSchedule = input<WithRef<IFeeSchedule>>();
  multiSelect = input<boolean>(false);
  scheduleSelected = output<WithRef<IFeeSchedule>>();

  groups = toSignal(
    this._feeScheduleStore.feeScheduleGroups$.pipe(shareReplayCold()),
    { initialValue: [] }
  );

  isCurrentFeeSchedule(
    currentSchedule: WithRef<IFeeSchedule> | undefined,
    schedule: WithRef<IFeeSchedule>
  ): boolean {
    if (!currentSchedule) {
      return false;
    }
    return this.multiSelect() ? false : isSameRef(currentSchedule, schedule);
  }
}
